export const SET_INVESTMENT_AMOUNT = "investment/SET_INVESTMENT_AMOUNT";
export const SET_INVESTMENT_AMOUNT_SUCCESS =
  "investment/SET_INVESTMENT_AMOUNT_SUCCESS";

export const GET_TRUEONE_CREDITS = "investment/GET_TRUEONE_CREDITS";
export const GET_TRUEONE_CREDITS_SUCCESS =
  "investment/GET_TRUEONE_CREDITS_SUCCESS";
